/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_Create_Guide_TitleInputs */



/**
* | output |
* | --- |
* | "Create new KNP guide" |
*
* @param {Knp_Manager_Create_Guide_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_create_guide_title = /** @type {((inputs?: Knp_Manager_Create_Guide_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Create_Guide_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer un nouveau guide KNP")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuen KNP-Leitfaden erstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea una nuova guida KNP")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создать новый путеводитель по КНП")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear nueva guía KNP")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建新的克鲁格国家公园指南")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいKNPガイドを作成する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नई केएनपी गाइड बनाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criar novo guia do KNP")
	return /** @type {LocalizedString} */ ("Create new KNP guide")
});